import { render, staticRenderFns } from "./ArtifactJob.yaml?vue&type=template&id=376a4c5e&component"
import script from "./ArtifactJob.yaml?vue&type=script&lang=ts&component"
export * from "./ArtifactJob.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports